const en = {
    seoTitle: 'Contact',
    seoDescription: 'Book a consultation with Ura Advisory in Prishtina, Kosovo. Tell us about your business and we reply within one working day, in English or Albanian.',
    breadcrumb: 'Contact',
    hero: {
        eyebrow: 'Contact',
        title: 'Book a consultation',
        text: 'Tell us where your finances stand and what you need. We reply within one working day to arrange a call.'
    },
    form: {
        title: 'Tell us about your business',
        intro: 'Fields marked with an asterisk are required.',
        name: 'Full name',
        email: 'Email',
        company: 'Company',
        companyHint: 'If the company is not registered yet, write the planned name.',
        country: 'Country',
        countryPlaceholder: 'Select a country',
        phone: 'Phone',
        optional: 'optional',
        service: 'Service of interest',
        servicePlaceholder: 'Select a service',
        message: 'Message',
        messagePlaceholder: 'A few lines about your business, what you need and any deadlines.',
        time: 'Preferred time for a call',
        timePlaceholder: 'Select a time',
        consentBefore: 'I agree that Ura Advisory may use these details to answer my request, as described in the',
        consentLink: 'privacy policy',
        consentAfter: '.',
        submit: 'Send request',
        pending: 'Sending',
        honeypot: 'Leave this field empty',
        errors: {
            name: 'Please enter your name.',
            email: 'Please enter a valid email address.',
            company: 'Please enter your company name.',
            country: 'Please select a country.',
            phone: 'Please check the phone number.',
            service: 'Please select a service.',
            message: 'Please write a short message of at least 10 characters.',
            consent: 'Please accept the privacy policy so we can answer you.'
        },
        errorSummary: 'Please check the highlighted fields.',
        failure: 'We could not send your request. Please try again in a moment.',
        rateLimited: 'You have sent several requests in a short time. Please wait a while and try again.',
        successTitle: 'Thank you, your request has been sent',
        successText: 'We will reply within one working day to arrange a time for the call.',
        again: 'Send another request'
    },
    options: {
        countries: [
            { value: 'XK', label: 'Kosovo' },
            { value: 'AL', label: 'Albania' },
            { value: 'MK', label: 'North Macedonia' },
            { value: 'ME', label: 'Montenegro' },
            { value: 'GB', label: 'United Kingdom' },
            { value: 'US', label: 'United States' },
            { value: 'DE', label: 'Germany' },
            { value: 'CH', label: 'Switzerland' },
            { value: 'AT', label: 'Austria' },
            { value: 'IT', label: 'Italy' },
            { value: 'FR', label: 'France' },
            { value: 'NL', label: 'Netherlands' },
            { value: 'SE', label: 'Sweden' },
            { value: 'TR', label: 'Turkey' },
            { value: 'OTHER', label: 'Other country' }
        ],
        extraServices: [
            { value: 'pricing', label: 'Pricing and packages' },
            { value: 'client-portal', label: 'Client portal' },
            { value: 'other', label: 'Something else' }
        ],
        times: [
            { value: 'morning', label: 'Morning, 09:00 to 12:00 CET' },
            { value: 'afternoon', label: 'Afternoon, 13:00 to 17:00 CET' },
            { value: 'flexible', label: 'Any time during working hours' }
        ]
    },
    next: {
        title: 'What happens next',
        steps: [
            { title: 'We read your request', text: 'It goes straight to the people who will work with you, not to a sales queue.' },
            { title: 'We reply within one working day', text: 'We confirm a 30-minute call at the time you prefer, by phone or video.' },
            { title: 'You receive a written proposal', text: 'After the call we send the scope, the fee and the date we can start.' }
        ]
    },
    details: [
        { label: 'Response time', value: 'Within one working day' },
        { label: 'Office', value: 'Prishtina, Kosovo' },
        { label: 'Languages', value: 'English and Albanian' },
        { label: 'Time zone', value: 'Central European Time (CET)' }
    ],
    portal: {
        title: 'Already a client?',
        text: 'Log in to the client portal to message your team directly.',
        link: 'Client login'
    },
    ctaTitle: 'Not ready to talk yet?',
    ctaText: 'See what each package includes and what affects the price.'
}

const sq: typeof en = {
    seoTitle: 'Kontakti',
    seoDescription: 'Rezervoni një konsultë me Ura Advisory në Prishtinë. Na tregoni për biznesin tuaj dhe ju përgjigjemi brenda një dite pune, në shqip ose anglisht.',
    breadcrumb: 'Kontakti',
    hero: {
        eyebrow: 'Kontakti',
        title: 'Rezervoni një konsultë',
        text: 'Na tregoni ku qëndrojnë financat tuaja dhe çfarë ju nevojitet. Ju përgjigjemi brenda një dite pune për të caktuar një bisedë.'
    },
    form: {
        title: 'Na tregoni për biznesin tuaj',
        intro: 'Fushat me yll janë të detyrueshme.',
        name: 'Emri dhe mbiemri',
        email: 'Email',
        company: 'Kompania',
        companyHint: 'Nëse kompania nuk është regjistruar ende, shkruani emrin e planifikuar.',
        country: 'Shteti',
        countryPlaceholder: 'Zgjidhni shtetin',
        phone: 'Telefoni',
        optional: 'opsionale',
        service: 'Shërbimi që ju intereson',
        servicePlaceholder: 'Zgjidhni shërbimin',
        message: 'Mesazhi',
        messagePlaceholder: 'Disa rreshta për biznesin tuaj, çfarë ju nevojitet dhe afatet që keni.',
        time: 'Koha e preferuar për bisedë',
        timePlaceholder: 'Zgjidhni kohën',
        consentBefore: 'Pajtohem që Ura Advisory t’i përdorë këto të dhëna për t’iu përgjigjur kërkesës sime, siç përshkruhet në',
        consentLink: 'politikën e privatësisë',
        consentAfter: '.',
        submit: 'Dërgo kërkesën',
        pending: 'Duke u dërguar',
        honeypot: 'Lëreni këtë fushë bosh',
        errors: {
            name: 'Ju lutemi shkruani emrin tuaj.',
            email: 'Ju lutemi shkruani një adresë të vlefshme emaili.',
            company: 'Ju lutemi shkruani emrin e kompanisë.',
            country: 'Ju lutemi zgjidhni shtetin.',
            phone: 'Ju lutemi kontrolloni numrin e telefonit.',
            service: 'Ju lutemi zgjidhni shërbimin.',
            message: 'Ju lutemi shkruani një mesazh të shkurtër me të paktën 10 shkronja.',
            consent: 'Ju lutemi pranoni politikën e privatësisë që t’ju përgjigjemi.'
        },
        errorSummary: 'Ju lutemi kontrolloni fushat e shënuara.',
        failure: 'Kërkesa juaj nuk u dërgua. Ju lutemi provoni përsëri pas pak.',
        rateLimited: 'Keni dërguar disa kërkesa në kohë të shkurtër. Ju lutemi prisni pak dhe provoni përsëri.',
        successTitle: 'Faleminderit, kërkesa juaj u dërgua',
        successText: 'Ju përgjigjemi brenda një dite pune për të caktuar kohën e bisedës.',
        again: 'Dërgo një kërkesë tjetër'
    },
    options: {
        countries: [
            { value: 'XK', label: 'Kosova' },
            { value: 'AL', label: 'Shqipëria' },
            { value: 'MK', label: 'Maqedonia e Veriut' },
            { value: 'ME', label: 'Mali i Zi' },
            { value: 'GB', label: 'Mbretëria e Bashkuar' },
            { value: 'US', label: 'Shtetet e Bashkuara' },
            { value: 'DE', label: 'Gjermania' },
            { value: 'CH', label: 'Zvicra' },
            { value: 'AT', label: 'Austria' },
            { value: 'IT', label: 'Italia' },
            { value: 'FR', label: 'Franca' },
            { value: 'NL', label: 'Holanda' },
            { value: 'SE', label: 'Suedia' },
            { value: 'TR', label: 'Turqia' },
            { value: 'OTHER', label: 'Shtet tjetër' }
        ],
        extraServices: [
            { value: 'pricing', label: 'Çmimet dhe paketat' },
            { value: 'client-portal', label: 'Portali i klientit' },
            { value: 'other', label: 'Diçka tjetër' }
        ],
        times: [
            { value: 'morning', label: 'Paradite, 09:00 deri 12:00 CET' },
            { value: 'afternoon', label: 'Pasdite, 13:00 deri 17:00 CET' },
            { value: 'flexible', label: 'Në çdo kohë gjatë orarit të punës' }
        ]
    },
    next: {
        title: 'Çfarë ndodh më pas',
        steps: [
            { title: 'E lexojmë kërkesën tuaj', text: 'Ajo shkon drejtpërdrejt te njerëzit që do të punojnë me ju, jo në një radhë shitjesh.' },
            { title: 'Përgjigjemi brenda një dite pune', text: 'Konfirmojmë një bisedë 30-minutëshe në kohën që preferoni, me telefon ose video.' },
            { title: 'Merrni një ofertë me shkrim', text: 'Pas bisedës ju dërgojmë fushëveprimin, tarifën dhe datën kur mund të fillojmë.' }
        ]
    },
    details: [
        { label: 'Koha e përgjigjes', value: 'Brenda një dite pune' },
        { label: 'Zyra', value: 'Prishtinë, Kosovë' },
        { label: 'Gjuhët', value: 'Shqip dhe anglisht' },
        { label: 'Zona kohore', value: 'Ora e Evropës Qendrore (CET)' }
    ],
    portal: {
        title: 'Jeni tashmë klient?',
        text: 'Hyni në portalin e klientit për t’i shkruar drejtpërdrejt ekipit tuaj.',
        link: 'Hyrja e klientit'
    },
    ctaTitle: 'Ende jo gati për bisedë?',
    ctaText: 'Shikoni çfarë përfshin secila paketë dhe çfarë ndikon në çmim.'
}

export const siteContact = { en, sq }
